import gql from 'graphql-tag';
import AdminProductCategoryAllFragment from '../fragments/AdminProductCategoryAllDataFragment';

export default gql`
query ProductCategory($id: Int!) {
    adminProductCategoryById(id:$id) {
        ...AdminProductCategoryAllDataFragment
    }
}
${AdminProductCategoryAllFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/productCategory.ts